import React, { useMemo, useState } from 'react'
import { employeeList } from '../../data/pointEarnData';
import { Box, Button, createTheme, Stack, ThemeProvider, useMediaQuery, useTheme } from '@mui/material';
import ComponentBackdrop from '../../components/backdrop';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import PointModal from './modal';
import CustomTheme from '../../theme/customTheme';

const EmployeeList = () => {
  const rows = employeeList;
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
      //   renderCell: (params) => {
      //     return (
      //       <Link
      //         to={`/view-employee/${params.value}`}
      //         style={{ textDecoration: "underline", color: "black" }}
      //       >
      //         {params.value}
      //       </Link>
      //     );
      //   },
    },
    {
      field: "type",
      headerName: "Type",
      width: 150,
    },
    {
      field: "mission",
      headerName: "Mission",
      width: 150,
      flex: 1,
    },
    {
      field: "points",
      headerName: "Points",
      width: 100,
    },
    {
      field: "remarks",
      headerName: "Remarks",
      width: 150,
      flex: 1,
    },
    {
      field: "missionCompletedDate",
      headerName: "Completed Date",
      width: 150,
      flex: 1,
    },
  ];

  return (
    <Box style={{ width: "100%" }}>
      {/* <ComponentBackdrop open={openBackdrop} /> */}

      {/* <ThemeProvider theme={CustomTheme}> */}
      <DataGrid
        columns={columns}
        rows={rows}
        showToolbar
        pageSizeOptions={[5, 10, { value: 50, label: "50" }]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10 },
          },
        }}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "skeleton",
          },
          disableToolbarButton: {
            csvOptions: "true",
            printOptions: "true",
          },
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true }
          },
        }}
        // checkboxSelection
        //   onRowSelectionModelChange={(id) => {
        //     onSelectedCheckbox(id, rows);
        //   }}
        disableRowSelectionOnClick
        localeText={{ noRowsLabel: "No records found" }}
      />
      {/* </ThemeProvider> */}
    </Box>
  )
}

export default EmployeeList